import React from 'react';

import ConfiguracaoPixAutomaticoFormPageContainer from './ConfiguracaoPixAutomaticoFormPageContainer';

export class ConfiguracaoPixAutomaticoFormPage extends React.Component{

    
    render(){
        return (
           <ConfiguracaoPixAutomaticoFormPageContainer {...this.props} />
        )
    }
}
